import {CommonModule, registerLocaleData} from '@angular/common';
import {LOCALE_ID, ModuleWithProviders, NgModule} from '@angular/core';
import {HistoricalValuesGridComponent} from '../historical-values/historical-values-grid/historical-values-grid.component';
import {HistoricalValuesFiltersComponent} from '../historical-values/historical-values-filters/historical-values-filters.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {AppRoutingModule} from '../app-routing.module';
import {HistoricalValuesGraphComponent} from '../historical-values/historical-values-graph/historical-values-graph.component';
import {UiSwitchModule} from 'ngx-ui-switch';
import {HistoricalValuesComponent} from '../historical-values/historical-values.component';
import {OAuthModule} from 'angular-oauth2-oidc';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {ApiModule, BASE_PATH} from '../../api';
import {NumericTextboxModule} from 'ngx-numeric-textbox';
import {BsDatepickerModule, CollapseModule, TabsModule} from 'ngx-bootstrap';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {environment} from '../../environments/environment';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptor} from '../services/auth/token.interceptor';
import {AuthGuard} from '../services/auth/auth.guard';
import {AuthenticationService} from '../services/auth/authentication.service';
import {RoleService} from '../services/auth/role.service';
import {HistoricalValuesService} from '../historical-values/services/historical-values.service';
import {FiltersService} from '../historical-values/historical-values-filters/filters.service';
import localeDE from '@angular/common/locales/de';
import {AgGridModule} from 'ag-grid-angular';

registerLocaleData(localeDE);

@NgModule({
  declarations: [
    HistoricalValuesComponent,
    HistoricalValuesGraphComponent,
    HistoricalValuesFiltersComponent,
    HistoricalValuesGridComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    RouterModule,
    BrowserAnimationsModule,
    OAuthModule.forRoot(),
    UiSwitchModule,
    NgxChartsModule,
    ApiModule,
    NumericTextboxModule,
    AgGridModule.withComponents([]),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    AngularFontAwesomeModule
  ],
  exports: [HistoricalValuesComponent,
    HistoricalValuesGraphComponent,
    HistoricalValuesFiltersComponent,
    HistoricalValuesGridComponent
  ]
})
export class PriceHistoryModule {
  static forRoot(configObject): ModuleWithProviders {
    console.log('getting config object: ' + configObject);
    return {
      ngModule: PriceHistoryModule,
      providers: [
        {
          provide: LOCALE_ID,
          useValue: environment.GLOBALS.DEFAULT_LOCALE_ID
        }, {
          provide: BASE_PATH,
          useValue: configObject.basePath
        }, {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        },
        AuthGuard,
        AuthenticationService,
        RoleService,
        HistoricalValuesService,
        FiltersService
      ]
    };
  }
}
